'use strict';

(function () {

    function redirect(goto) {
        if (goto !== '') {
            window.location = goto;
        }
    }

    const selectEl = document.getElementById('redirectSelect');

    selectEl.onchange = function(){
        const goto = this.value;
        redirect(goto);

    };
})();